import _objectWithoutProperties from "/Users/oct16/work/Cat/timecat-issue-helper/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default (function (_ref) {
  var components = _ref.components,
      props = _objectWithoutProperties(_ref, ["components"]);

  return /*#__PURE__*/React.createElement(MDXTag, {
    name: "wrapper",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u6240\u8C13\u300E\u91CD\u73B0\u300F\uFF0C\u5C31\u662F\u4E00\u6BB5\u53EF\u4EE5\u8FD0\u884C\u5E76\u5C55\u793A\u4E00\u4E2A bug \u5982\u4F55\u53D1\u751F\u7684\u4EE3\u7801\u3002"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h5",
    components: components
  }, "\u6587\u5B57\u662F\u4E0D\u591F\u7684"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u5982\u679C\u4F60\u9047\u5230\u4E00\u4E2A\u95EE\u9898\uFF0C\u4F46\u662F\u53EA\u63D0\u4F9B\u4E86\u4E00\u4E9B\u6587\u5B57\u63CF\u8FF0\uFF0C\u6211\u4EEC\u662F\u4E0D\u53EF\u80FD\u4FEE\u590D\u8FD9\u4E2A bug \u7684\u3002\u9996\u5148\uFF0C\u6587\u5B57\u5728\u63CF\u8FF0\u6280\u672F\u95EE\u9898\u65F6\u7684\u8868\u8FBE\u96BE\u5EA6\u548C\u4E0D\u7CBE\u786E\u6027\uFF1B\u5176\u6B21\uFF0C\u95EE\u9898\u7684\u771F\u5B9E\u539F\u56E0\u6709\u5F88\u591A\u53EF\u80FD\uFF0C\u5B83\u5B8C\u5168\u6709\u53EF\u80FD\u662F\u4E00\u4E2A\u4F60\u6839\u672C\u6CA1\u6709\u63D0\u53CA\u7684\u56E0\u7D20\u5BFC\u81F4\u7684\u3002\u91CD\u73B0\u662F\u552F\u4E00\u80FD\u591F\u53EF\u9760\u5730\u8BA9\u6211\u4EEC\u7406\u89E3\u95EE\u9898\u672C\u8D28\u7684\u65B9\u5F0F\u3002"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h5",
    components: components
  }, "\u91CD\u73B0\u5FC5\u987B\u662F\u53EF\u8FD0\u884C\u7684"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, "\u622A\u56FE\u548C\u89C6\u9891\u4E0D\u662F\u91CD\u73B0"), "\u3002\u5B83\u4EEC\u4EC5\u4EC5\u8BC1\u660E\u4E86 bug \u7684\u5B58\u5728\uFF0C\u4F46\u5374\u4E0D\u80FD\u63D0\u4F9B\u5173\u4E8E bug \u662F\u5982\u4F55\u53D1\u751F\u7684\u4FE1\u606F\u3002\u53EA\u6709\u53EF\u8FD0\u884C\u7684\u4EE3\u7801\u63D0\u4F9B\u4E86\u5B8C\u6574\u7684\u4E0A\u4E0B\u6587\uFF0C\u5E76\u8BA9\u6211\u4EEC\u53EF\u4EE5\u8FDB\u884C\u771F\u6B63\u7684 debug \u800C\u4E0D\u662F\u7A7A\u60F3\u548C\u731C\u6D4B\u3002\u5F53\u7136\uFF0C\u5728\u63D0\u4F9B\u7684\u91CD\u73B0\u7684\u524D\u63D0\u4E0B\uFF0C\u89C6\u9891\u6216\u662F gif \u52A8\u753B\u53EF\u4EE5\u5E2E\u52A9\u89E3\u91CA\u4E00\u4E9B\u6BD4\u8F83\u96BE\u7528\u6587\u5B57\u63CF\u8FF0\u7684\u4EA4\u4E92\u884C\u4E3A\u3002"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h5",
    components: components
  }, "\u91CD\u73B0\u5E94\u5F53\u5C3D\u91CF\u7CBE\u7B80"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u6709\u4E9B\u7528\u6237\u4F1A\u76F4\u63A5\u7ED9\u6211\u4EEC\u4E00\u6574\u4E2A\u9879\u76EE\u7684\u4EE3\u7801\uFF0C\u7136\u540E\u5E0C\u671B\u6211\u4EEC\u5E2E\u5FD9\u627E\u51FA\u95EE\u9898\u6240\u5728\u3002\u6B64\u7C7B\u8BF7\u6C42\u6211\u4EEC\u901A\u5E38\u4E0D\u4E88\u63A5\u53D7\uFF0C\u56E0\u4E3A\uFF1A"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "ul",
    components: components
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components,
    parentName: "li"
  }, "\u4F60\u5BF9\u4F60\u7684\u9879\u76EE\u7684\u4EE3\u7801\u7ED3\u6784\u53EF\u80FD\u5DF2\u7ECF\u975E\u5E38\u719F\u6089\uFF0C\u4F46\u6211\u4EEC\u5E76\u4E0D\u662F\u3002\u9605\u8BFB\u3001\u8FD0\u884C\u3001\u5206\u6790\u4E00\u4E2A\u5B8C\u5168\u964C\u751F\u7684\u9879\u76EE\u662F\u6781\u5176\u8017\u8D39\u65F6\u95F4\u548C\u7CBE\u529B\u7684\u3002")), /*#__PURE__*/React.createElement(MDXTag, {
    name: "li",
    components: components,
    parentName: "ul"
  }, /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components,
    parentName: "li"
  }, "\u7531\u4E8E\u6D89\u53CA\u4E86\u5927\u91CF\u4E1A\u52A1\u4EE3\u7801\uFF0C\u95EE\u9898\u53EF\u80FD\u662F\u4F60\u7684\u4EE3\u7801\u9519\u8BEF\uFF0C\u800C\u4E0D\u662F TimeCat \u7684 bug \u6240\u5BFC\u81F4\u7684\u3002"))), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u4E00\u4E2A\u6700\u5C0F\u5316\u7684\u91CD\u73B0\u610F\u5473\u7740\u5B83\u7CBE\u786E\u5730\u5B9A\u4F4D\u4E86 bug \u672C\u8EAB - \u5B83\u5E94\u5F53\u53EA\u5305\u542B\u80FD\u591F\u89E6\u53D1 bug \u7684", /*#__PURE__*/React.createElement(MDXTag, {
    name: "strong",
    components: components,
    parentName: "p"
  }, "\u6700\u5C11\u91CF"), "\u7684\u4EE3\u7801\u3002\u4F60\u5E94\u5F53\u5C3D\u53EF\u80FD\u5730\u5254\u9664\u4EFB\u4F55\u8DDF\u8BE5 bug \u65E0\u5173\u7684\u90E8\u5206\u3002"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "h5",
    components: components
  }, "\u5982\u4F55\u63D0\u4F9B\u4E00\u4E2A\u91CD\u73B0"), /*#__PURE__*/React.createElement(MDXTag, {
    name: "p",
    components: components
  }, "\u9664\u975E\u4F60\u7684 bug \u53EA\u6709\u5728\u6784\u5EFA\u5DE5\u5177\u4E0B\u624D\u80FD\u91CD\u73B0\uFF0C\u5426\u5219\u6211\u4EEC\u5EFA\u8BAE\u4F7F\u7528 ", /*#__PURE__*/React.createElement("a", {
    href: "https://codesandbox.io",
    target: "_blank"
  }, "CodeSandbox"), " / ", /*#__PURE__*/React.createElement("a", {
    href: "https://codepen.io/",
    target: "_blank"
  }, "CodePen"), " \u6765\u63D0\u4F9B\u91CD\u73B0"));
});